import slink from 'src/router/middleware/authentification/slink.js'
import registration from 'src/router/middleware/authentification/registration.js'

// Keep critical routes for login/logout synchronous, to avoid chunk loading errors
import LoginContainer from 'src/views/Authentification/Login/LoginContainer.vue'

const ActivationKey = () => import('src/views/Authentification/Registration/RegistrationActivationKey.vue')
const Credentials = () => import('src/views/Authentification/Registration/RegistrationCredentials.vue')
const Teaching = () => import('src/views/Authentification/Registration/RegistrationTeaching.vue')
const Confirmation = () => import('src/views/Authentification/Registration/RegistrationConfirmation.vue')
const Copyright = () => import('src/views/Authentification/Registration/RegistrationCopyright.vue')
const Email = () => import('src/views/Authentification/Registration/RegistrationEmail.vue')
const Shortcuts = () => import('src/views/Authentification/Registration/RegistrationShortcuts.vue')
const Username = () => import('src/views/Authentification/Registration/RegistrationUsername.vue')
const Password = () => import('src/views/Authentification/Registration/RegistrationPassword.vue')
const RegistrationWrapper = () => import('src/views/Authentification/Registration/RegistrationWrapper.vue')
const Intro = () => import('src/views/Authentification/Registration/RegistrationIntro.vue')
const ChildCredentials = () => import('src/views/Authentification/Registration/RegistrationChildCredentials.vue')
const ChildConfirmation = () => import('src/views/Authentification/Registration/RegistrationChildConfirmation.vue')
const Block = () => import('src/views/Authentification/Registration/Block.vue')

const routes = [
  {
    path: '/:slink/register/',
    component: LoginContainer,
    children: [
      {
        path: 'activate',
        redirect: { name: 'login-sign-in' },
        component: ActivationKey,
        name: 'register-activation-key',
        meta: {
          isPublic: true,
          middleware: [slink],
          group: 'register',
          transitionPoint: 2,
          headerText: 'global.headers.registration'
        }
      }
    ]
  },

  {
    path: '/:slink/register/',
    component: LoginContainer,
    children: [
      {
        path: 'activate/:code?',
        component: ActivationKey,
        name: 'register-activation-key-no-redirect',
        meta: {
          isPublic: true,
          middleware: [slink],
          group: 'register',
          transitionPoint: 2,
          enableSwHotReload: true,
          enableSwReload: true,
          headerText: 'global.headers.registration'
        }
      }
    ]
  },

  {
    path: '/:slink/registration/',
    component: RegistrationWrapper,
    children: [
      {
        path: 'intro-parent-1',
        name: 'register-intro_parent_1',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'intro-parent-2',
        name: 'register-intro_parent_2',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'intro-parent-3',
        name: 'register-intro_parent_3',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'intro-student-1',
        name: 'register-intro_student_1',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'intro-student-2',
        name: 'register-intro_student_2',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'intro-student-3',
        name: 'register-intro_student_3',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'intro-teacher-1',
        name: 'register-intro_teacher_1',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'intro-teacher-2',
        name: 'register-intro_teacher_2',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'intro-teacher-3',
        name: 'register-intro_teacher_3',
        component: Intro,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'disclaimer',
        component: Copyright,
        name: 'register-disclaimer',
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 1,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'credentials',
        name: 'register-credentials',
        component: Credentials,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 2,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'email',
        name: 'register-email',
        component: Email,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 3,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'username',
        name: 'register-username',
        component: Username,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 4,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'password',
        name: 'register-password',
        component: Password,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 5,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'shortcuts',
        name: 'register-shortcuts',
        component: Shortcuts,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 7,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'grade',
        name: 'register-grade',
        component: Shortcuts,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 8,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'teaching',
        name: 'register-teaching',
        component: Teaching,
        meta: {
          isPublic: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 9,
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'confirmation',
        name: 'register-confirmation',
        component: Confirmation,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 10,
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'block',
        name: 'register-user-editing-block',
        component: Block,
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          transitionPoint: 10,
          headerText: 'global.headers.registration'
        }
      },

      {
        path: 'child-credentials',
        component: ChildCredentials,
        name: 'register-child-credentials',
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      },
      {
        path: 'child-confirmation',
        component: ChildConfirmation,
        name: 'register-child-confirmation',
        meta: {
          isPublic: true,
          interceptChildRegistration: true,
          middleware: [slink, registration],
          group: 'register',
          headerText: 'global.headers.registration'
        }
      }
    ]
  }
]

export default routes
